import axios from 'axios';
import Vue from 'vue';

const retryTime = 30000;

export default {
  namespaced: true,
  state: {},
  mutations: {
    addConfiguration(state, { config, data }) {
      Vue.set(state, axios.getUri(config), data);
    },
    resetStore(state) {
      for (const key of Object.keys(state)) {
        delete state[key];
      }
    }
  },
  getters: {
    getConfiguration: state => config => {
      const data = state[axios.getUri(config)];
      if (data?.isLoading) return undefined;
      else return data;
    }
  },
  actions: {
    loadConfiguration({ commit, state }, config) {
      if (state[axios.getUri(config)]?.isLoading) return;
      commit('addConfiguration', { config, data: { isLoading: true } });
      axios({ ...config, method: 'get' }).then(
        response => commit('addConfiguration', { config, data: response }),
        () => window.setTimeout(() => commit('addConfiguration', { config, data: undefined }), retryTime)
      );
    }
  }
}
